import moment from "moment-timezone";
import { useState } from "react";
import DatePicker from "react-datepicker";
import Modal from "../../../components/Modal/Modal";

const CompleteStatusModal = ({ showModal, onClose, onSave }) => {
  const [formData, setFormData] = useState({ date: null });
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.date) {
      setError("Please select a date");
      return;
    }

    onSave(formData.date);   // Send formatted date to parent
    onClose();               // Close modal
    setFormData({ date: null });
    setError("");
  };

  return (
    <Modal title="Add the Complete Date" show={showModal} onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <div className="mt-6">
          <label className="dark-H head-4 mb-2 required:*:">
            Complete Date <span className="red-D">*</span>
          </label>

          <DatePicker
            className="body-N"
            dateFormat="MM/dd/yyyy"
            placeholderText="MM/DD/YYYY"
            selected={
              formData.date
                ? moment.tz(formData.date, "America/New_York").toDate()
                : null
            }
            onChange={(date) => {
              const formatted = moment
                .tz(date, "America/New_York")
                .format("YYYY-MM-DD");

              setFormData({ date: formatted });
              setError("");
            }}
          />

          {error && <span className="body-S red-D">{error}</span>}
        </div>

        <div className="mt-7">
          <button type="submit" className="save-button light-L head-5 green-bg-H">
            Save
          </button>

          <button
            type="button"
            onClick={onClose}
            className="green-H ml-5"
          >
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default CompleteStatusModal;
